import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import {
    Container,
    Button,
    Col,
    Row,
    Input,
    Label,
    Card,
    CardBody,
    InputGroup
} from "reactstrap";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Flatpickr from "react-flatpickr";
import CurrencyFormat from 'react-currency-format';

import {
    getCompanies as onGetCompanies,
    getPeriods as onGetPeriods,
    getListAccount as onGetListAccount,
    submitInputBeginningBalance as onSubmitInputBeginningBalance,
} from "../../store/actions";


import { useSelector, useDispatch } from "react-redux";
import PulseLoader from "react-spinners/PulseLoader";
import { NotifHelper } from "../../components/Common/NotifHelper"

const InputBeginningBalance = (props) => {

    //meta title
    document.title = "Input | Beginning Balance | Des Counts";
    const [newTransaction, SetNewTransaction] = useState([])
    const [optionAccount, setOptionAccount] = useState(null)
    const { companies, loadingCompany, periods, loadingPeriod,
        accounts, loadingAccount, loadingSubmit } = useSelector(state => ({
        companies: state.Company.companies,
        loadingCompany: state.Company.loading,
        periods: state.Period.periods,
        loadingPeriod: state.Period.loading,
        accounts: state.Account.listAccount,
        loadingAccount: state.Account.loading,
        loadingSubmit: state.Period.loadingSubmitInput,
    }));

    const [selectedCompany, setSelectedCompany] = useState(null);
    const [optionCompany, setOptionCompany] = useState([]);
    function handleSelectCompany(e) {
        setSelectedCompany(e)
    }

    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [optionPeriod, setOptionPeriod] = useState([]);
    function handleSelectPeriod(e) {
        setSelectedPeriod(e)
    }

    const dispatch = useDispatch();

    const uploadSubmit = () => {
        //check valid
        var validDetail = true
        newTransaction.map(item => {
            if (item.accountId == null) {
                validDetail = false
            }
            if (item.debit < 0) {
                validDetail = false
            }
            if (item.credit < 0) {
                validDetail = false
            }
        })
        if (!validDetail || !selectedCompany || !selectedPeriod || newTransaction.length == 0) {
            NotifHelper.error("Data not valid")
        }
        else {
            dispatch(onSubmitInputBeginningBalance({
                companyId: selectedCompany.value,
                periodId: selectedPeriod.value,
                detail: newTransaction.map(item => {
                    return {
                        accountId: item.accountId,
                        accountCode: item.accountCode,
                        debit: item.debit,
                        credit: item.credit,
                    }
                })
            }, props.history))
        }
    }

    function handleDeleteData(item) {
        const curData = newTransaction;
        var idx = curData.indexOf(item)
        if (idx > -1) {
            curData.splice(idx, 1)
            SetNewTransaction([...curData])
        }
    }

    function handleDebitChange(val, id) {
        const curData = newTransaction;
        curData.map(m => {
            if (m.id == id) {
                m.debit = isNaN(val.floatValue) ? 0 : val.floatValue
            }
        })
    }

    function handleCreditChange(val, id) {
        const curData = newTransaction;
        curData.map(m => {
            if (m.id == id) {
                m.credit = isNaN(val.floatValue) ? 0 : val.floatValue
            }
        })
    }

    function handleSelectAccount(val, id) {
        const curData = newTransaction;
        curData.map(m => {
            if (m.id == id) {
                m.accountId = val ? val.value : null
                var temp = optionAccount.filter(s => s.value == val.value)
                if(temp.length > 0){
                    m.accountCode = temp[0].accountCode
                }
            }
        })
    }

    useEffect(() => {
        dispatch(onGetCompanies({}))
    }, [dispatch])

    useEffect(() => {
        if (companies) {
            setOptionCompany(companies.map((item) => {
                return { label: item.name, value: item.id.toString() }
            }))
        }
    }, [companies])

    useEffect(() => {
        if (periods) {
            setOptionPeriod(periods.map((item) => {
                return { label: item.name, value: item.id.toString() }
            }))
        }
    }, [periods])

    useEffect(() => {
        if (accounts) {
            setOptionAccount(accounts.map(item => {
                return { label: item.code + " - " + item.name, value: item.id, accountCode: item.code }
            }))
        }
    }, [accounts]);

    useEffect(() => {
        if(!loadingSubmit){
            setSelectedCompany(null)
            setSelectedPeriod(null)
            SetNewTransaction([])
        }
    }, [loadingSubmit])

    const addTransaction = () => {
        const temp = {
            id: newTransaction.length > 0 ? newTransaction[newTransaction.length - 1].id + 1 : 1,
            date: null,
            accountId: null,
            accountCode: null,
            debit: 0,
            credit: 0
        };
        const tempTransaction = [...newTransaction, temp]
        SetNewTransaction(tempTransaction)
    }

    useEffect(() => {
        if (selectedCompany) {
            dispatch(onGetPeriods({ companyId: selectedCompany.value, isOpen: false}))
            dispatch(onGetListAccount({ companyId: selectedCompany.value }))
            SetNewTransaction([])
        }
    }, [selectedCompany])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Beginning Balance" breadcrumbItem={"Input Beginning Balance"} />
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody style={loadingSubmit ? { pointerEvents: "none" } : {}}>
                                    {
                                        !loadingSubmit &&
                                        <>
                                            <div className="d-flex">
                                                <div className="flex-grow-1  mx-1">
                                                    <Label>Company</Label>
                                                    <Select
                                                        value={selectedCompany}
                                                        onChange={handleSelectCompany}
                                                        options={optionCompany}
                                                        isLoading={loadingCompany}
                                                        className="select2-selection"
                                                        menuPosition="fixed"
                                                    />
                                                </div>
                                                <div className="flex-grow-1  mx-1">
                                                    <Label>Period</Label>
                                                    <Select
                                                        value={selectedPeriod}
                                                        onChange={handleSelectPeriod}
                                                        options={optionPeriod}
                                                        isLoading={loadingPeriod}
                                                        className="select2-selection"
                                                        isClearable={true}
                                                        menuPosition="fixed"
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    }
                                    <h5 className="mt-4 text-center">Transaction Data</h5>
                                    {
                                        newTransaction && newTransaction.map((item, i) => {
                                            return <Row className="mt-3" key={'row' + i}>
                                                <Col>
                                                    <div>
                                                        <Label>Account</Label>
                                                        <Select
                                                            onChange={(val) => {
                                                                handleSelectAccount(val, item.id)
                                                            }}
                                                            options={optionAccount}
                                                            isLoading={loadingAccount}
                                                            isClearable={false}
                                                            className="select2-selection"
                                                            menuPosition="fixed"
                                                        />
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div>
                                                        <Label>Debit</Label><Label className="text-danger">*</Label>
                                                        <CurrencyFormat value={item.debit} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0}
                                                            onValueChange={(values) => {
                                                                handleDebitChange(values, item.id)
                                                            }}
                                                            customInput={Input} className="text-end" />
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div>
                                                        <Label>Credit</Label><Label className="text-danger">*</Label>
                                                        <CurrencyFormat value={item.credit} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0}
                                                            onValueChange={(values) => {
                                                                handleCreditChange(values, item.id)
                                                            }}
                                                            customInput={Input} className="text-end" />
                                                    </div>
                                                </Col>
                                                <Col sm={1} className="text-center align-self-end">
                                                    <Button color="danger" onClick={() => {
                                                        handleDeleteData(item)
                                                    }}>
                                                        <i className="fa fa-trash"></i>
                                                    </Button>
                                                </Col>
                                            </Row>
                                        })
                                    }
                                    {
                                        !loadingSubmit &&
                                        <>
                                            <Row className="mb-3 mt-3">
                                                <Col className="text-center">
                                                    <Button color="secondary" onClick={addTransaction}>
                                                        <span><i className="fa fa-plus"></i> Add</span>
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <Row className="mt-3">
                                                <Col sm={12}>
                                                    <Button color="secondary" className="float-end"
                                                        disabled={loadingSubmit} onClick={() => {
                                                            props.history.push("/input-beginning-balance")
                                                        }}>
                                                        Cancel
                                                    </Button>
                                                    <Button color="success" className="me-2 float-end"
                                                        disabled={!selectedCompany || !selectedPeriod} onClick={uploadSubmit}>
                                                        Submit
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </>
                                    }
                                    {
                                        loadingSubmit &&
                                        <div className="d-flex justify-content-center my-5">
                                            <PulseLoader loading={loadingSubmit} color={'#FFF'} size={12} className="align-self-center" />
                                        </div>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

InputBeginningBalance.propTypes = {
    history: PropTypes.object,
};

export default withRouter(InputBeginningBalance)
